<template>
  <div class="flex items-center gap-2">
    <div class="flex items-center gap-2">
      <div
        v-if="prefix"
        class="text-secondary-900 text-sm 2xl:text-base 3xl:text-xl break-words py-2 whitespace-nowrap"
        v-html="
          parseTooltip(prefix, {
            fontSize: '14px',
            includeKatex: false,
          })
        "></div>
      <span class="relative top-1">👎</span>
    </div>
    <div class="flex flex-wrap justify-center items-center gap-3.5 px-4">
      <RangeSelect
        v-for="range in options"
        :id="range.id"
        :key="range.id"
        :title="range.title"
        :selected="isSelected(range.id)"
        @update:selected="emit('handleSelection', range.id)"/>
    </div>
    <div class="flex items-center gap-2">
      <div
        v-if="suffix"
        class="text-secondary-900 text-sm 2xl:text-base 3xl:text-xl break-words py-2 whitespace-nowrap"
        v-html="
          parseTooltip(suffix, {
            fontSize: '14px',
            includeKatex: false,
          })
        "></div>
      <span>👍</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import RangeSelect from '@/components/RangeSelect/RangeSelect.vue';
import type { PropType } from 'vue';
import type { RangeOptionType, ChoiceOptionType } from '@amit/types';
import { parseTooltip } from '@amit/tiptap';

defineProps({
  options: {
    type: Array as PropType<RangeOptionType[] | ChoiceOptionType[]>,
    default: () => [],
  },
  prefix: {
    type: String,
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
  isSelected: {
    type: Function as PropType<(id: string) => boolean>,
    default: () => false,
  },
});

const emit = defineEmits(['handleSelection']);
</script>
